import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_FAMTARIF_SCHEMA_LITERAL = {
    title: 'Schéma FamTarifs',
    description: 'Décrit les spécificités tarifaires par famille',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        FA_CODEFAMILLE: { type: 'string' },
        FT_CATEGORIE: { type: 'number' },
        FT_COEF: { type: ['number', 'null'] },
        FT_PRIXTTC: { type: ['number', 'null'] },
        FT_ARRONDI: { type: ['number', 'null'] },
        FT_QTEMONT: { type: ['number', 'null'] },
        EG_CHAMP: { type: ['number', 'null'] },
        FT_DEVISE: { type: ['number', 'null'] },
        FT_REMISE: { type: ['number', 'null'] },
        FT_CALCUL: { type: ['number', 'null'] },
        FT_TYPEREM: { type: ['number', 'null'] }
    },
    required: [ 'CBMARQ', 'FA_CODEFAMILLE']
} as const;

const schemaTyped = toTypedRxJsonSchema(F_FAMTARIF_SCHEMA_LITERAL);
export type RxFFamTarifDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;
export const F_FAMTARIF_SCHEMA: RxJsonSchema<RxFFamTarifDocumentType> = F_FAMTARIF_SCHEMA_LITERAL;